import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Config from './plugins/config'
import DeviceType from './plugins/deviceType'
Vue.use(Config)
Vue.use(DeviceType)
import Cookies from 'js-cookie'
import api from "./http/api";

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import SvgIcon from '@/components/svgIcon/index';
Vue.component('icon', SvgIcon);

Vue.config.productionTip = false

Vue.prototype.$api = api;
Vue.prototype.$cookie = Cookies
Vue.prototype.$EventBus = new Vue()

new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')

